import React from "react";
import cn from "classnames";
import { useAppContext } from "~hooks";
import * as styles from "./styles.module.scss";

const LoadingOverlay = () => {
  const { loading } = useAppContext();

  return (
    <div className={cn(styles.container, { [styles.loading]: loading })}>
      <div className={styles.spinner} />
    </div>
  );
};

export default LoadingOverlay;
